import React, { Fragment } from "react";
import { Link } from "react-router-dom";

const UserSubscriptionItem = ({
  subscription,
  user,
  profile,
  showModal,
  setShowModal,
}) => {
  return (
    <Fragment>
      {user.user !== profile.user && (
        <div className="user-section-alt">
          <div className="friends-user-container">
            <Link to={`/${subscription.channelid}`}>
              <div className="friend-user-avi-container">
                <div className="avi-color-border red">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${subscription.avatar}`}
                    className="friend-user-avi"
                  />
                </div>
              </div>
            </Link>
            <div className="friend-user-info">
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="red name-font">
                      {subscription.firstname} {subscription.lastname}
                    </span>
                  </li>
                  <li className="user-online-item">{subscription.jobtitle}</li>
                  <li className="user-online-item">
                    {subscription.location.city}, {subscription.location.state}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="friends-buttons-container">
            <div className="friend-button-container">
              <button className="friend-button background-red">
                <i className="fas fa-medal mx-5"></i>
                Subscribed
              </button>
            </div>
            {user.channelid === profile.channelid && (
              <i
                onClick={() => {
                  if (showModal) {
                    setShowModal(false);
                  } else {
                    setShowModal(true);
                  }
                }}
                className="fas fa-ellipsis-v fa-lg ellipsis-pos red"
              ></i>
            )}
            {showModal && (
              <div className="modal">
                <ul className="modal-items">
                  <li className="modal-item">
                    <i className="fas fa-flag mx-5 white"></i>
                    Report
                  </li>
                  <li className="modal-item">
                    <i className="fas fa-ban mx-5 white"></i>
                    Block
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default UserSubscriptionItem;
